const toSessionString = (s) => Array.isArray(s) ? s.join(',') : (s || '');

export const buildCreateRolePayload = (newRole) => {
  return {
    RoleCode: newRole.roleCode,
    RoleDescription: newRole.roleDescription,
    Status: newRole.status ? 'Active' : 'Inactive',
    SessionAccess: toSessionString(newRole.sessionAccess),
    CreatedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    CreatedOn: new Date().toISOString(),
    IsDeleted: false,
  };
};

export const buildUpdateRolePayload = (newRole, originalRole) => {
  return {
    RoleCode: newRole.roleCode,
    RoleDescription: newRole.roleDescription,
    Status: newRole.status ? 'Active' : 'Inactive',
    SessionAccess: toSessionString(newRole.sessionAccess),
    CreatedBy: originalRole.originalCreatedBy || originalRole.insertedBy,
    CreatedOn: originalRole.originalCreatedOn,
    ModifiedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    ModifiedOn: new Date().toISOString(),
    IsDeleted: false,
  };
};

export const buildDeleteRolePayload = (role) => {
  return {
    RoleCode: role.roleCode,
    RoleDescription: role.roleDescription,
    Status: role.status,
    SessionAccess: role.sessionAccess,
    CreatedBy: role.originalCreatedBy || role.insertedBy,
    CreatedOn: role.originalCreatedOn,
    ModifiedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    ModifiedOn: new Date().toISOString(),
    IsDeleted: true,
  };
};

export const buildRoleGridEntry = (payload, sessionAccessArray) => {
  return {
    status: payload.Status,
    roleCode: payload.RoleCode,
    roleDescription: payload.RoleDescription,
    sessionAccess: sessionAccessArray.join(', '),
    insertedBy: payload.CreatedBy,
    insertedOn: new Date().toLocaleString('en-GB'),
    modifiedBy: payload.CreatedBy,
    modifiedOn: new Date().toLocaleString('en-GB'),
    originalCreatedBy: payload.CreatedBy,
    originalModifiedBy: payload.CreatedBy,
    originalCreatedOn: payload.CreatedOn,
    originalModifiedOn: payload.CreatedOn,
  };
};
